import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import * as en from './locales/en';
import * as fr from './locales/fr';
import * as nl from './locales/nl';

const resources = { en, fr, nl };

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: ['general'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    }
  });

i18next.availableLanguages = Object.keys(resources);

export default i18next;
